<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-xl-8">
                    <div class="trinka_cloud_banner_text">
                        <h1>트링카의 주요 기능</h1>
                        <p>트링카는 세계 최초 문법 및 언어 개선 툴로서 학술 및 기술 글쓰기에 맞춤 설계되어
                            <br /> 있습니다. 두드러진 특징은 저자를 도우며 문법 및 맞춤법 검사뿐 아니라 전반적인
                            <br /> 언어 향상을 보장한다는 점입니다.</p>
                        <!-- <a id="FeaturesGetStarted" href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">Get Started</a> -->
                    </div>
                </div>
                <div class="col-xl-4">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/FeaturesTopBanner.png" alt="banner">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="advanceGrammerSpellCheck_section backgrondSecitons_outer">
        <div class="container">
            <div class="row">
                <div class="col-xl-5">
                    <div class="spellcheck_heading advanceGrammerSlider">
                        <h2>효과적인 글 작성을 원하세요?  Trinka를 사용하세요.</h2>
                        <div class="HeadingSubLine"></div>
                        <p class="">학술적 글쓰기는 명료하고 간결한 형식을 갖추어야 하며,
                            <br /> 객관적이고 가독성이 있어야 합니다 Trinka는 이 모든 측면을 검사하여 글의 완성도를 높여 줍니다. </p>
                    </div>
                </div>
                <div class="col-xl-7">
                    <div class="spellcheckGrammerCheck_slider">
                        <div id="spellcheckGrammerCheck" class="carousel slide" data-ride="carousel">
                            <!-- Indicators -->
                            <div class="bullet_points_sections">
                                <ul class="carousel-indicators">
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="0" class="active">
                                        <span></span>
                                        고급 문법
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="1">
                                        <span></span>
                                        문장 구조
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="2">
                                        <span></span>
                                        단어 선택
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="3">
                                        <span></span>
                                        어법과
                                        <br /> 스타일
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="4">
                                        <span></span>
                                        미국/영국식 영어 구분
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="5">
                                        <span></span>
                                        고급 철자
                                    </li>
                                </ul>
                            </div>

                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <h4>고급 문법</h4>
                                    <p>3,000가지 이상의 복잡한 문법 오류를 교정하며, 이는 다른 프로그램의
                                        <br /> 한계를 뛰어넘는 수준입니다. Trinka를 사용하면 여러분의 글도
                                        <br /> 달라집니다.</p>
                                    <div class="featuresExampleText">
                                        <p>Neither the healthy individuals nor the patient
                                            <span class="wrongText">recognize</span>
                                            <span class="rightText">recognizes</span> the visual discrepancies.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>문장 구조</h4>
                                    <p>글의 주제를 감안하여 문장의 구조를 교정합니다.</p>
                                    <div class="featuresExampleText">
                                        <p>The students don't enjoy
                                            <span class="wrongText">to go</span>
                                            <span class="rightText">going</span> over the same rules again and again.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>단어 선택</h4>
                                    <p>잘못된 단어 선택과 모호한 글을 바로잡습니다. Trinka를 사용하면
                                        <br /> 정확하고 명확한 글을 쓸 수 있습니다.</p>
                                    <div class="featuresExampleText">
                                        <p>One of the reasons is
                                            <span class="wrongText">because</span>
                                            <span class="rightText">that</span> the fabrication cost
                                            <span class="wrongText">for</span>
                                            <span class="rightText">of</span> steel members depends upon the material.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>어법과 스타일</h4>
                                    <p>격식체 어조를 갖춘 글이 되도록 교정합니다. 자신 있고 간결한
                                        <br /> 언어로 인상적인 글쓰기가 가능해집니다.</p>
                                    <div class="featuresExampleText">
                                        <p>However, his method is novel and is
                                            <span class="wrongText">very much</span>
                                            <span class="rightText">considerably</span> different from the classical method.
                                        </p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>미국식 /영국식 영어 구분</h4>
                                    <p>미국식 영어와 영국식 영어 구분 및 선택이 가능하여 독자 및 저널
                                        <br /> 스타일에 부합하는 글이 될 수 있습니다.</p>
                                    <div class="featuresExampleText">
                                        <p>The upper limbs of the patient were
                                            <span class="wrongText">paralysed</span>
                                            <span class="rightText">paralyzed.</span>
                                        </p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>고급 철자</h4>
                                    <p>문맥에 맞는 철자 검사뿐만 아니라 전문 분야에 적합한 단어를 선택
                                        <br /> 및 교정합니다.</p>
                                    <div class="featuresExampleText">
                                        <p>The
                                            <span class="wrongText">Bonferoni</span>
                                            <span class="rightText">Bonferroni</span> test was used to check for statistical significance.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="advanceGrammerSpellCheck_section publishEnhancements_slider">
        <div class="container">
            <div class="row">
                <div class="col-xl-7">
                    <div class="spellcheckGrammerCheck_slider">
                        <div id="publishEnhancements" class="carousel slide" data-ride="carousel">
                            <!-- Indicators -->
                            <div class="bullet_points_sections">
                                <ul class="carousel-indicators">
                                    <li data-target="#publishEnhancements" data-slide-to="0" class="active">
                                        <span></span>
                                        스타일 가이드
                                        <br /> 선호 사항
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="1">
                                        <span></span>
                                        단어 수 축약
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="2">
                                        <span></span>
                                        비편향적인
                                        <br /> 언어
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="3">
                                        <span></span>
                                        모호한 언어
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="4">
                                        <span></span>
                                        기술적 표현
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="5">
                                        <span></span>
                                        학술적 어조
                                    </li>
                                </ul>
                            </div>

                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <h4>스타일 가이드의 선호 사항</h4>
                                    <p>AMA와 APA 같은 스타일 가이드에서 선호하는 표현을 제안합니다. Trinka를 통해 출판해도 손색 없는 글이 될 수 있습니다.</p>
                                    <div class="featuresExampleText">
                                        <p>The man
                                            <span class="wrongText">suffered from</span>
                                            <span class="rightText">had</span> chronic kidney disease.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>단어 수 축약</h4>
                                    <p>중복되고 장황한 어구를 간결하게 해줍니다. 저널의 가이드라인에 맞는 단어 축약도 가능합니다!</p>
                                    <div class="featuresExampleText">
                                        <p>Bcl6 deficiency in T cells resulted in
                                            <span class="wrongText">the reduction of
                                            </span>
                                            <span class="rightText">reduced</span> mRNA expression.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>비편향적인 언어</h4>
                                    <p>편향적이거나 민감한 언어를 교정하여 효율적으로 논지를 펼칠 수 있습니다.</p>
                                    <div class="featuresExampleText">
                                        <p>The
                                            <span class="wrongText">retarded children</span>
                                            <span class="rightText">children with mental retardation</span> were taken to a different facility.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>모호한 언어</h4>
                                    <p>구체적이고 직접적인 글이 되도록 돕습니다. 명확하고 효율적인 의사전달을 할 수 있습니다.</p>
                                    <div class="featuresExampleText">
                                        <p>
                                            <span class="wrongText">Some studies</span>
                                            <span class="rightText">Studies</span> have shown that children not participating in co-curricular activities
                                            may not develop the necessary social skills in adulthood.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>기술적 표현</h4>
                                    <p>전문 분야에 적합한 단어 사용을 제안하여 각 분야의 독자들이 읽기 쉬운 컨텐츠로 거듭납니다.</p>
                                    <div class="featuresExampleText">
                                        <p>Anti-aquaporin 4 antibody testing may be useful in cases of pediatric
                                            <span class="wrongText">transverse myelitis with long spinal cord lesions
                                            </span>
                                            <span class="rightText">longitudinally extensive transverse myelitis.</span>
                                        </p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>학술적 어조</h4>
                                    <p>글을 격식체 어조로 교정해 독자들에게 인상을 남길 수 있습니다. 이제 쉽게 전문 글쓰기를 할 수 있습니다!</p>
                                    <div class="featuresExampleText">
                                        <p>Children actively engage in activities
                                            <span class="wrongText">like</span>
                                            <span class="rightText">such as</span> outdoor games, skits, and other team activities.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-5">
                    <div class="spellcheck_heading">
                        <h2>출판해도 손색 없는 글쓰기</h2>
                        <div class="HeadingSubLine"></div>
                        <p>학술 출판 표준에 따라 글의 어조와 전달력, 표현을 개선합니다. 이제 스트레스 없이 학술적 글쓰기를 할 수 있습니다.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolboxs_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="writerBox_heading">
                        <h2>저자의 소프트웨어와 연동</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections sections_height_set bg-right-position d-flex align-items-center" style="background-image: url('../../../assets/images/Reverstoolbox_backgrond_keyBenafits.png');">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content pc-check-img">
                            <img src="../../../assets/images/pc-checker.png" alt="pc-checker">
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>표절 검사</h3>
                            <p>
                                최첨단 텍스트 유사도 탐지 알고리즘인 iThenticate와 다양한 과학 분야를 총망라하는 최대 규모의 유료 출판 데이터베이스로 무장한 최고 품질의 표절 검사를 경험해 보세요.
                            </p>
                            <a [routerLink]="['/features/plagiarism-check']">
                                더 읽어보기
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="icon">
                            </a>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>자동 파일 교정</h3>
                            <p>선호하는 환경에서 계속 작업할 수 있습니다. MS Word 문서를 업로드한 후 트링카가 몇 분 내에 논문을 자동 교정할 동안 한숨 돌리세요. 변경 내용 추적이 표시된
                                파일을 다운로드합니다.</p>
                            <a href="https://www.trinka.ai/kr/features/auto-file-edit">
                                자세히 보기
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="icon">
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/autoFileEdit_image.png" alt="auto-file-edit">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections publication_outer_sections sections_height_set">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content publication_checks_icons publication_checks_section">
                            <!-- <img src="../../../assets/images/PublicationReadinessChecksImg.png" alt=""> -->
                            <ul>
                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/JournalScope.svg" alt="JournalScope">
                                    </div>
                                    <h3>저널 범위 매칭</h3>
                                    <span>2 Checks</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/TechnicalCompliance.svg" alt="technical">
                                    </div>
                                    <h3>기술적 준수</h3>
                                    <span>3 Checks</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/EthicalCompliance.svg" alt="ethical">
                                    </div>
                                    <h3>윤리기준 준수</h3>
                                    <span>5 Checks</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/AuthorshipDetails.svg" alt="authorship">
                                    </div>
                                    <h3>원저자 정보</h3>
                                    <span>4 Checks</span>
                                </li>
                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/ReferenceDetails.svg" alt="reference">
                                    </div>
                                    <h3>참고문헌 정보</h3>
                                    <span>1 Check</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/FirgureTable.svg" alt="figure">
                                    </div>
                                    <h3>표와 그림</h3>
                                    <span>2 Checks</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/ClinicalTrials.svg" alt="clinical">
                                    </div>
                                    <h3>임상시험 정보</h3>
                                    <span>1 Check</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="../../../assets/images/KeywordsAndSummary.svg" alt="keywords">
                                    </div>
                                    <h3>키워드 & 요약</h3>
                                    <span>2 Checks</span>
                                </li>
                                <i></i>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>출판 준비 체크</h3>
                            <p class="publicationCheck_decription">트링카 출판 준비 체크를 통해, 저널 선정부터 윤리기준
                                <br /> 준수까지 20가지 이상의 체크포인트로 문서를 평가하여
                                <br /> 출판 가능성을 높입니다.</p>
                            <!-- <b style="font-weight: 600;">곧 출시</b> -->
                            <a href="https://www.trinka.ai/kr/features/publication-readiness-checks">
                                자세히 보기
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="icon">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>일관성 체크</h3>
                            <p class="consistencyCheck_description">내용에 전달할 적합한 단어를 찾아도 어떤 곳은 하이픈을
                                <br /> 사용하고 어떤 곳은 하이픈 없이 남겨두는 경우가 있는
                                <br /> 것처럼, 트링카는 일관되지 않은 부분도 정확하게 찾아내기
                                <br /> 때문에 여러 번 클릭할 필요없이 한번의 클릭으로수정할
                                <br /> 수 있습니다.</p>
                            <a [routerLink]="['/features/consistency-check']">
                                자세히 보기
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="icon">
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_img_content consistency_checks_slider">
                            <div class="consistency_checks_slider_overlay"></div>
                            <!-- <img src="../../../assets/images/consistencyCheck_img.png" alt=""> -->
                            <div class="slider_consistency_check_section">
                                <div id="consistencySlider" class="carousel slide" data-ride="carousel">
                                    <ul class="carousel-indicators">
                                        <li data-target="#consistencySlider" data-slide-to="0" class="active"></li>
                                        <li data-target="#consistencySlider" data-slide-to="1"></li>
                                        <li data-target="#consistencySlider" data-slide-to="2"></li>
                                        <li data-target="#consistencySlider" data-slide-to="3"></li>
                                        <li data-target="#consistencySlider" data-slide-to="4"></li>
                                    </ul>
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <div class="carousel_inner_content">
                                                <div class="consistency_right_text">
                                                    <h2>Dashes</h2>
                                                    <div class="custom_radioButtons">
                                                        <p>
                                                            <input type="radio" id="ultra-violet" name="dashesCehcks" checked>
                                                            <label for="ultra-violet">ultra-violet (5 occurrences) </label>
                                                        </p>
                                                        <p>
                                                            <input type="radio" id="ultra_violet" name="dashesCehcks">
                                                            <label for="ultra_violet">ultra violet (5 occurrences) </label>
                                                        </p>
                                                    </div>
                                                    <button>Apply selected variant</button>
                                                </div>
                                                <div class="consistency_left_side">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    <ul>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_delete_icon.svg" alt="delete" title="Delete" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_IgnoreAll_Icons.svg" alt="ignore all" title="Ignore for all similler alerts" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/consistency_dislike_icon.svg" alt="dislike" title="Incorrect suggestions" style="width: 20px;">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item">
                                            <div class="carousel_inner_content">
                                                <div class="consistency_right_text">
                                                    <h2>Spacing</h2>
                                                    <div class="custom_radioButtons">
                                                        <p style="margin: 0;">
                                                            <input type="radio" id="addSpaicng" name="spacingChecks" checked>
                                                            <label for="addSpaicng">Add space</label>
                                                        </p>
                                                        <ul style="margin-bottom: 20px;">
                                                            <li>p
                                                                <0 <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>p
                                                                < 0 </li>
                                                                    <li>p=0
                                                                        <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>p = 0 </li>
                                                        </ul>
                                                        <p style="margin: 0px;">
                                                            <input type="radio" id="removingspacing" name="spacingChecks">
                                                            <label for="removingspacing">Remove space</label>
                                                        </p>
                                                        <ul>
                                                            <li>2D + DBT
                                                                <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>2D+DBT</li>
                                                            <li>p
                                                                < 0 <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>p
                                                                <0</li>
                                                        </ul>
                                                    </div>
                                                    <!-- <button>Apply selected variant</button> -->
                                                </div>
                                                <div class="consistency_left_side">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    <ul>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_delete_icon.svg" alt="delete" title="Delete" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_IgnoreAll_Icons.svg" alt="ignore all" title="Ignore for all similler aterls" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/consistency_dislike_icon.svg" alt="dislike" title="Incorrect suggestions" style="width: 20px;">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item">
                                            <div class="carousel_inner_content">
                                                <div class="consistency_right_text">
                                                    <h2>Numbers</h2>
                                                    <div class="custom_radioButtons">
                                                        <p style="margin: 0;">
                                                            <input type="radio" id="spelledOut" name="numberschecks" checked>
                                                            <label for="spelledOut">Spelled-out
                                                                <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/> Numeral</label>
                                                        </p>
                                                        <ul style="margin-bottom: 20px;">
                                                            <li>average six years
                                                                <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>average 6 years </li>
                                                            <!-- <li>average 6 years <img src="../../../assets/images/spacingArrow.png"/>average six years </li> -->
                                                        </ul>
                                                        <p style="margin: 0px;">
                                                            <input type="radio" id="numeralSection" name="numberschecks">
                                                            <label for="numeralSection">Numeral
                                                                <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/> Spelled-out</label>
                                                        </p>
                                                        <ul>
                                                            <li>waited 5 days
                                                                <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>waited five days</li>
                                                            <!-- <li>p < 0 <img src="../../../assets/images/spacingArrow.png"/>p<0</li> -->
                                                        </ul>
                                                    </div>
                                                    <!-- <button>Apply selected variant</button> -->
                                                </div>
                                                <div class="consistency_left_side">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    <ul>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_delete_icon.svg" alt="delete" title="Delete" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_IgnoreAll_Icons.svg" alt="ignore all" title="Ignore for all similler aterls" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/consistency_dislike_icon.svg" alt="dislike" title="Incorrect suggestions" style="width: 20px;">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item">
                                            <div class="carousel_inner_content">
                                                <div class="consistency_right_text">
                                                    <h2>Spelling</h2>
                                                    <div class="custom_radioButtons">
                                                        <p>
                                                            <input type="radio" id="colourSection" name="spellingchecks" checked>
                                                            <label for="colourSection">colour (4 occurences) </label>
                                                        </p>
                                                        <p>
                                                            <input type="radio" id="colorSections" name="spellingchecks">
                                                            <label for="colorSections">color (4 occurences) </label>
                                                        </p>
                                                    </div>
                                                    <button>Apply selected variant</button>
                                                </div>
                                                <div class="consistency_left_side">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    <ul>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_delete_icon.svg" alt="delete" title="Delete" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_IgnoreAll_Icons.svg" alt="ignore all" title="Ignore for all similler aterls" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/consistency_dislike_icon.svg" alt="dislike" title="Incorrect suggestions" style="width: 20px;">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item">
                                            <div class="carousel_inner_content">
                                                <div class="consistency_right_text">
                                                    <h2>Greek Letter Style</h2>
                                                    <div class="custom_radioButtons">
                                                        <p style="margin: 0;">
                                                            <input type="radio" id="GreekSpelledOut" name="Greekletterstyle" checked>
                                                            <label for="GreekSpelledOut">Spelled-out
                                                                <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/> Symbol</label>
                                                        </p>
                                                        <ul style="margin-bottom: 20px;">
                                                            <li>TNF-alpha"
                                                                <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>tnf-α"</li>
                                                            <li>"Beta particles
                                                                <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>"β particles</li>
                                                        </ul>
                                                        <p style="margin: 0px;">
                                                            <input type="radio" id="removingspacing" name="Greekletterstyle">
                                                            <label for="removingspacing">Symbol
                                                                <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/> Spelled-out</label>
                                                        </p>
                                                        <ul>
                                                            <li>TNF-α"
                                                                <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>TNF-alpha"</li>
                                                            <li>"β particles
                                                                <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>"beta particles</li>
                                                        </ul>
                                                    </div>
                                                    <!-- <button>Apply selected variant</button> -->
                                                </div>
                                                <div class="consistency_left_side">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    <ul>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_delete_icon.svg" alt="delete" title="Delete" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/Consistency_IgnoreAll_Icons.svg" alt="ignore all" title="Ignore for all similler aterls" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="../../../assets/images/consistency_dislike_icon.svg" alt="dislike" title="Incorrect suggestions" style="width: 20px;">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections publication_outer_sections personal_outer_section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content publication_checks_section pd_after">
                            <div class="personal_dictionary_section">
                                <div class="personal_dic_left_text">
                                    <h2>Spelling
                                        <span>
                                            <i class="fa fa-plus"></i>Add to dictionary</span>
                                    </h2>
                                    <div class="personal_dic_text_section">
                                        <p class="personal_wrong_text">nanotubol</p>
                                        <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>
                                        <p class="personal_right_text">nanotubes</p>
                                    </div>
                                    <p>Please check the spelling</p>
                                </div>
                                <div class="consistency_left_side">
                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                    <ul>
                                        <li>
                                            <img src="../../../assets/images/Consistency_delete_icon.svg" alt="delete" title="Delete" style="width: 22px;">
                                        </li>
                                        <!-- <li><img src="../../../assets/images/Consistency_IgnoreAll_Icons.svg" alt="ignore all" title="Ignore for all similler aterls" style="width: 22px;"></li> -->
                                        <li>
                                            <img src="../../../assets/images/consistency_dislike_icon.svg" alt="dislike" title="Incorrect suggestions" style="width: 20px;">
                                        </li>
                                    </ul>
                                </div>
                                <!-- <a>
                                    <i class="fa fa-check" aria-hidden="true"></i>
                                    <i class="fa fa-plus"  aria-hidden="true"></i> 
                                    <span class="dictionary_text_section">Add to dictionary</span>
                                    <span class="dictionary_add_text">Added</span>
                                </a> -->
                            </div>
                            <!-- <img src="../../../assets/images/personalDictionary_img.png" alt=""> -->
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>개인 사전</h3>
                            <p class="consistencyCheck_description">“My Dictionary"에 단어를 추가하면 향후 글에서는 트링카가 철자 오류로 표시하지 않습니다.</p>
                            <a [routerLink]="['/features/personal-dictionary']">
                                자세히 보기
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="icon">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections downloadTrackedchangesOuter_section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>변경 추적 표시된 파일 다운로드</h3>
                            <p class="downloadTrack_description">선택된 트링카 에디터에서 여러가지 변경된 내용을 보여주는 추적
                                <br /> 파일을 다운로드하여 최종적으로 마무리하세요. </p>
                            <!-- <a href="">Read More</a> -->
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="forMobileDownloadTrackChanges">
                            <img src="../../../assets/images/DownloadFileTrackChanges.png" alt="downalod trach changes" />
                        </div>
                        <div class="toolbox_img_content downloadTrackedchanges_section">
                            <!-- <img src="../../../assets/images/downloadTrackedChanged_img.png" alt=""> -->
                            <div class="downloadCleanFile">
                                <!-- <p class="cleanDownloadfile"></p> -->
                                <p>
                                    <span class='rightWordTExt'>However,</span> additional factors
                                    <span class='rightWordTExt'>influencing</span> patient prognosis and
                                    <span class='rightWordTExt'>reducing</span> HDL-C and Apo A1 levels were assessed.</p>
                            </div>
                            <div class="downloadWithTrackedChangesFile">
                                <!-- <p class="TrackedChangesFile"></p> -->
                                <p>
                                    <span class='wrognWordText'>On the other hand </span>
                                    <span class='rightWordTExt'>However,</span> additional factors
                                    <span class='wrognWordText'>which influence </span>
                                    <span class='rightWordTExt'>influencing</span> patient prognosis and
                                    <span class='wrognWordText'>leading to a reduction in </span>
                                    <span class='rightWordTExt'>reducing</span> HDL-C and Apo A1 levels were assessed.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections publication_outer_sections personal_outer_section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content publication_checks_section pd_after">
                            <div class="personal_dictionary_section">
                                <div class="personal_dic_left_text">
                                    <h2>Spelling
                                        <b>
                                            <i class="fa fa-plus"></i>Add to dictionary</b>
                                    </h2>
                                    <div class="personal_dic_text_section">
                                        <p class="personal_wrong_text">nanotubol</p>
                                        <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>
                                        <p class="personal_right_text">nanotubes</p>
                                    </div>
                                    <div class="acceptAll_buttons_sections">
                                        <p>Accept for all similar alerts</p>
                                        <i>
                                            <img src="../../../assets/images/info.svg" alt="icon">
                                        </i>
                                    </div>
                                    <p>Please check the spelling</p>
                                </div>
                                <div class="consistency_left_side">
                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                    <ul>
                                        <li>
                                            <img src="../../../assets/images/Consistency_delete_icon.svg" alt="delete" title="Delete" style="width: 22px;">
                                        </li>
                                        <li class="acceptAll_rejectAll">
                                            <img src="../../../assets/images/AcceptAll_consistencyCheks.svg" alt="accept all" title="Ignore for all similler aterls" style="width: 22px;">
                                        </li>
                                        <li>
                                            <img src="../../../assets/images/consistency_dislike_icon.svg" alt="dislike" title="Incorrect suggestions" style="width: 20px;">
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>모두 승인/무시</h3>
                            <p>반복해서 클릭할 필요 없습니다! 트링카에서는 한 번의 클릭으로 모두 승인 또는 무시 할 수 있습니다.</p>
                            <!-- <a href="">Read More</a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="writeToolbox_inner_sections publication_outer_sections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content publication_checks_section acceptAll_outerSection">
                            <div class="acceptIgnore_all_section">
                                <a>
                                    <i class="fa fa-check" aria-hidden="true"></i>
                                    <i class="fa fa-plus"  aria-hidden="true"></i> 
                                    <span class="dictionary_text_section">Add to dictionary</span>
                                    <span class="dictionary_add_text">Added</span>
                                </a>
                                <b>Accept for all similler alert</b>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>Accept/Ignore All</h3>
                            <p>No more repetitive clicking! Trinka allows you to accept or ignore all repetitive
                                suggestions in one click.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

    </div>

    <div class="forpersonlized_sections">
        <p>망설이지 말고 지금 사용해보세요.</p>
        <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">무료 가입하기</a>
    </div>
</div>